import './login-form.css'
import {Link, Redirect} from "react-router-dom";
import {Field, reduxForm} from "redux-form";
import React from "react";
import {registrationProfile} from "../../redux/profile-reducer";
import {connect} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RegistrationForm = (props) => {
    const onSubmit = (formData) => {
        props.registrationUser(formData.first_name, formData.last_name, formData.email, formData.password)
    }
    if (props.isLogin) {
        return <Redirect to={"/profile"}/>
    }
    if (props.isError){
        toast.error(props.errorText)
    }
    return (
        <div className="container">
            <div className="row">
                <ToastContainer/>
                <RegistrationReduxForm onSubmit={onSubmit}/>
            </div>
        </div>

    )
};

const RegistrationFormInputs = (props) => {
    return (
        <div className="panel panel-primary">
            <div className="panel-body">
                <form onSubmit={props.handleSubmit}>
                    <div className="form-group">
                        <h2>Create account</h2>
                    </div>
                    <div className="form-group">
                        <label className="control-label">Your first name</label>
                        <Field name="first_name" type="text" maxLength="50" className="form-control"
                               placeholder="Enter first name"
                               component={"input"}/>
                    </div>
                    <div className="form-group">
                        <label className="control-label">Your last name</label>
                        <Field name="last_name" type="text" maxLength="50" className="form-control"
                               placeholder="Enter last name"
                               component={"input"}/>
                    </div>
                    <div className="form-group">
                        <label className="control-label">Email</label>
                        <Field name="email" type="email" maxLength="50" className="form-control"
                               placeholder="Enter email"
                               component={"input"}/>
                    </div>
                    <div className="form-group">
                        <label className="control-label">Password</label>
                        <Field name="password" type="password" maxLength="25" className="form-control"
                               placeholder="Enter your password" length="40" component={"input"}/>
                    </div>
                    <div className="form-group">
                        <button className="btn btn-info btn-block">Create
                            your account
                        </button>
                    </div>
                    <p className="form-group">By creating an account, you agree to our <a href="#">Terms of
                        Use</a> and our <a href="#">Privacy Policy</a>.</p>

                    <p>Already have an account? <Link to="/login">Sign in</Link></p>
                </form>
            </div>
        </div>
    )
};
const RegistrationReduxForm = reduxForm(
    {
        form: 'registration'
    }
)(RegistrationFormInputs);
const mapStateToProps = (state) => ({
    isLogin: state.profilePage.isLogin,
    isError: state.profilePage.isError,
    errorText: state.profilePage.errorText

});
const mapDispatchToProps = dispatch => {
    return {
        registrationUser: (first_name, last_name, email, password) => dispatch(registrationProfile(first_name, last_name, email, password)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(RegistrationForm);